import { Outlet } from "react-router-dom";
import { NavLink } from "react-router-dom";

import "../styles/LegalAndCookiesLayout.css";

export default function LegalAndCookiesLayout() {
  return (
    <div className="legal-and-cookies-container">
      <nav class="legal-nav">
        <NavLink to="." end className="legal-tab">
          Terms and Conditions
        </NavLink>
        <NavLink to="privacy-policy" className="legal-tab">
          Privacy Policy
        </NavLink>
      </nav>
      <Outlet />
    </div>
  );
}
